import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material/";

type LoaderProps = {
  margin?: number;
  immediate?: boolean;
  style?: React.CSSProperties;
};

const Loader = ({ margin, immediate = false, style = {} }: LoaderProps) => {
  const [showSpinner, setShowSpinner] = useState(immediate);

  useEffect(() => {
    const timer = setTimeout(() => setShowSpinner(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!showSpinner) return null;

  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
        margin: `${margin ?? 80}px 0`,
        ...style,
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default Loader;
